<template>
  <v-layout
    class="w-100 mb-0"
  >
    <div class="jumbotron jumbotron-newsletter pt-10 pb-5">
      <v-container class="py-0">
        <h2 class="v-row-title display-1 text-center mb-2">{{ $t('headband.newsletter.title') }}</h2>
        <p class="subtitle-1 font-weight-light text-center">{{ $t('headband.newsletter.overline') }} </p>
        <v-row justify="center" align="center">
          <v-col
            cols="12" sm="6"
            class="white--text pl-3 pr-3"
          >
            
            <v-form
              v-model="valid"
              ref="form"
              @submit.prevent="onSubmit"
              class="subscribe"
            >
              <div class="subscribe__wrapper d-flex align-start jsutify-content-between">
                <v-text-field
                  :label="$t('headband.newsletter.placeholder')"
                  :placeholder="$t('headband.newsletter.placeholder')"
                  v-model="email"
                  :rules="emailRules"
                  type="email"
                  class="subscribe__mail"
                  :loading="submitLoading"
                  :success="success"
                  :success-messages="successMessage"
                  :error="error"
                  :error-messages="errorMessage"
                  :disabled="disabled"
                  full-wifth
                  required
                  flat
                  clearable
                  solo
                ></v-text-field>
                <v-btn
                  tile
                  elevation="0"
                  color="primary"
                  :disabled="!valid"
                  type="submit"
                >
                  <v-icon v-if="!valid || !success || error">mdi-email-outline</v-icon>
                  <v-icon v-if="valid && success && !error">mdi-email-check-outline</v-icon>
                </v-btn>
              </div>
            </v-form>

          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-layout>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'block-newsletter',
  data () {
    return {
      valid: false,
      submitLoading: false,
      emailRules: [
        v => !!v || this.$t('field.mailRequired'),
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('field.mailValid')
      ],
      email: "",
      success: false,
      successMessage: "",
      error: false,
      errorMessage: "",
      disabled: false,
      body: {
        listIds: [ 23 ],
        updateEnabled: false,
        attributes: {
          NOM: "",
          PRENOM: "",
        },
        email: ""
      }
    }
  },

  created() {
    if (this.user) {
      this.email = this.user.mail
    }
  },

  computed: {
    ...mapGetters("auth", [
      "user",
    ]),
  },

  methods: {
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.submitLoading = true
        this.body.email = this.email
        if (this.user) {
          const [ firstname, lastname ] = this.user.fullname.split(' ')
          this.body.attributes.PRENOM = firstname
          this.body.attributes.NOM = lastname
          this.body.listIds = [ 23 ]
          this.disabled = true
        }
        axios({
          url: `https://api.sendinblue.com/v3/contacts`,
          data: this.body,
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'api-key': process.env.VUE_APP_SENDINGBLUE,
            'content-type': 'application/json'
          }
        })
        .then (() => {
          this.error = false
          this.errorMessage = ""

          this.success = true
          this.successMessage = this.$t('headband.newsletter.messages.success')
        })
        .catch (() => {
          this.success = false
          this.successMessage = ""

          this.error = true
          this.errorMessage = this.$t('headband.newsletter.messages.error')
        })
        .finally (() => {
          this.submitLoading = false
        })

      }
    }
  },
  watch: {
    email: function (mail) {
      this.error = false
      this.errorMessage = ""
      this.success = false
      this.successMessage = ""
      this.email = mail
    }
  }
}
</script>
<style lang="scss" scoped>
.jumbotron:before {
  background: rgba(0,92,170,.1);
}
.subscribe__mail {
  width: calc(100% - 60px);
  font-size: 1.25em;
}
.subscribe button {
  width: 60px;
  height: 48px !important;
}
</style>
